import { ListSeriesAPIQueryParams, PaginatedSeriesListList, listSeries, retrieveSeries } from '@goldcast/api/backend';
import logger from '@goldcast/logger';

const sortByMap = {
  0: 'name',
  1: '-name',
  2: 'events__start_time',
  3: '-events__start_time',
  4: 'updated_at',
  5: '-updated_at'
};

const filterByMap = {
  0: '', // no filter applied to get all series
  1: 'upcoming',
  2: 'past'
};

const actions = {
  async loadSeriesList(
    { dispatch, state, rootGetters },
    payload: { fetchAll?: boolean; workspaceId?: string; isNoWorkspaceOptionSelected?: boolean } = {}
  ) {
    const { currentPage, seriesPerPage, sortBy, searchTerm, filterBy, selectedTagIds } = state;
    const fetchAll = payload.fetchAll ?? false;
    const notUseRegistrantsCount = rootGetters['org/getCurrentOrg']?.notUseRegistrantsCount || false;

    const orgId: string = rootGetters['org/getCurrentOrgId'];
    const sortQuery = sortByMap[sortBy] || '';
    const filterQuery = filterByMap[filterBy] || '';
    const queryParams: ListSeriesAPIQueryParams = {
      limit: seriesPerPage,
      offset: (currentPage - 1) * seriesPerPage,
      organization: orgId,
      ordering: sortQuery,
      name: searchTerm,
      filtering: filterQuery,
      workspace: payload.workspaceId ?? '',
      // @ts-ignore
      min: notUseRegistrantsCount ? notUseRegistrantsCount : undefined,
      tag: selectedTagIds,
      get_tags: true
    };

    if (payload.isNoWorkspaceOptionSelected) {
      queryParams.workspace__isnull = true;
    }

    if (fetchAll) {
      delete queryParams.limit;
    }

    try {
      const seriesData: PaginatedSeriesListList = await listSeries({
        queryParams,
        queryParamsStringifyOptions: {
          arrayFormat: 'repeat'
        }
      });
      return seriesData;
    } catch (error) {
      dispatch(
        'studioToast/triggerToast',
        { msg: 'Error Loading Series, Please Try Again', mode: 'error' },
        { root: true }
      );
    }
  },
  async fetchSeriesById({ dispatch, commit, rootGetters }, { seriesId }) {
    const currentOrg = rootGetters['org/getCurrentOrg'];
    const notUseRegistrantsCount = currentOrg?.notUseRegistrantsCount || false;

    try {
      const seriesData = await retrieveSeries({
        id: seriesId,
        queryParams: {
          // @ts-ignore
          min: notUseRegistrantsCount ? notUseRegistrantsCount : undefined,
          get_tags: true,
          get_cached_data: true
        }
      });
      commit('studioSeriesList/addSeriesToSeriesList', seriesData, { root: true });
      return seriesData;
    } catch (error) {
      dispatch(
        'studioToast/triggerToast',
        { msg: 'Failed to load registration page builder', mode: 'error' },
        { root: true }
      );
      logger.warn('[store/actions] StudioSeriesList store: load series failed', { error });
    }
  }
};

export default actions;
